import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

// Draw-order Excel export (the program book's draw section). One workbook:
// a "Summary" sheet (comp, entrants, status, seed, number base) plus one sheet
// per drawn comp with its running order. `rows` is the /draws/export shape —
// [{ competition, entrantCount, draw: { order, seed, numberBase, ... } | null }];
// the single-comp export passes the same shape with one row.
const statusText = (r) => {
  if (!r.draw) return "no draw";
  return r.draw.locked ? `locked v${r.draw.version}` : `draft v${r.draw.version}`;
};

const headerStyle = {
  font: { bold: true },
  border: { bottom: { style: "thin" } },
};

export const exportDrawsToExcel = async (rows, filename) => {
  const workbook = new ExcelJS.Workbook();

  const summary = workbook.addWorksheet("Summary");
  summary.columns = [
    { header: "Code", width: 14 },
    { header: "Competition", width: 40 },
    { header: "Entrants", width: 10 },
    { header: "Status", width: 12 },
    { header: "Seed", width: 34 },
    { header: "Numbers from", width: 14 },
  ];
  summary.getRow(1).eachCell((cell) => {
    cell.style = headerStyle;
  });
  rows.forEach((r) => {
    summary.addRow([
      r.competition.code,
      r.competition.name,
      r.entrantCount,
      statusText(r),
      r.draw ? r.draw.seed : "",
      r.draw && r.draw.numberBase ? r.draw.numberBase : "",
    ]);
  });

  rows
    .filter((r) => r.draw && (r.draw.order || []).length)
    .forEach((r) => {
      // Sheet names cap at 31 chars; comp codes are short and unique.
      const sheet = workbook.addWorksheet(String(r.competition.code).slice(0, 31));
      sheet.columns = [
        { header: "#", width: 8 },
        { header: r.draw.entryType === "team" ? "Team" : "Dancer", width: 34 },
        { header: "School", width: 34 },
      ];
      sheet.getRow(1).eachCell((cell) => {
        cell.style = headerStyle;
      });
      r.draw.order.forEach((o) => {
        sheet.addRow([o.number, o.label || o.schoolName, o.schoolName]);
      });
    });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};
